export default __webpack_public_path__ + "static/media/work-step-logo.0f8bd04a.png";